import React, { useEffect, useState } from "react";
import "./App.css";
import "./Wolfstyle.css";
import { Hexagon, MagnifyingGlass, TelegramLogo } from "phosphor-react";
import ProductCard from "./ProductCard";
import axios from "axios";
import { Bounce, ToastContainer, toast } from "react-toastify";

function Game() {

    const [gamesList, setGamesList] = useState([]);

    const [msisdn, setMsisdn] = useState(null);
    const [productId, setProductId] = useState(null);

  

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const msisdn = queryParams.get('m');        // Extract 'm' as msisdn
        const productId = queryParams.get('p');     // Extract 'p' as productId

        getAllGames();
        return;


        if (msisdn && productId) {
            // msisdn and productId are present, proceed with your logic

            //check if user is subscribe to that product
            

            if(checkSubscription(productId,msisdn)){
                getAllGames();
            }


        } else {
            // Redirect to home if either is missing
            window.location.href = "/";
        }
    }, []);
  

    function checkSubscription(productId,msisdn) {

        let success = false;
    
        let config = {
          method: 'get',
          url: `https://api.mfilter.libroafrica.com/api/request/check-sub?productId=${productId}&hashed_msisdn=${msisdn}`,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
        };
    
        axios.request(config)
          .then((response) => {
            if(response.data.subscribed){
                
                success = true;
            }else{
                toast.error('Subscription not found!', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                  });

                  setTimeout(() => {
                    window.href = `/?productId=${productId}`
                  }, 5000);
            }

          })
          .catch((error) => {
            toast.error('🦄 Something went wrong! Subscription not found!', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
            });
          });
    
        return success;
      }


    function getAllGames(){
        fetch('https://games-list.libroafrica.com/api/game/all-active')
        .then(response => response.json())
        .then(data => {
            setGamesList(data);
        })
        .catch(error => {
            toast.error('Error fetching card data:', error, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
              });
        });
    }

    return (
        <>
            {/* Main Content */}

            <body data-aos-easing="ease" data-aos-duration="2000" data-aos-delay="5000" style={{ overflow: "visible" }} >
                <header className="bg-nu2 header-section">
                    <div className="sticky top-0 header xl:py-4 sm:pt-6 pt-8">
                        <div className="container mx-auto max-w-screen-xl">
                            <nav className="flex justify-between items-center">
                                <a href="/" className="flex items-center">
                                    <img
                                        className="sm:w-[40px] w-[25px] sm:h-[40px] h-[25px]"
                                        src="/images/logo.png"
                                        alt="GameWolf Logo"
                                    />
                                    <span className="pl-2 xl:text-[32px] lg:text-[28px] md:text-[24px] text-[20px] text-nu1 font-medium">
                                        GameWolf
                                    </span>
                                </a>
                            </nav>
                        </div>
                    </div>
                </header>

                <section className="bred-crumb lg:pt-[8rem] pt-[6rem] pb-[2rem]">
                    <div className="container mx-auto max-w-screen-xl">
                        <div className="text-nu1">
                            <h2 className="">Games</h2>

                        </div>
                    </div>
                </section>


                <section className="sm:pt-[60px] pt-12 lg:pb-[100px] md:pb-20 sm:pb-16 pb-12 bg-nu2">
                    <div className="container">
                        <div className="">


                            <div className="sm:pb-10 pb-6 flex justify-between globl max-xl:flex-wrap">
                                <div className="flex max-lg:flex-wrap aos-init aos-animate" data-aos="fade-right">
                                    <div className="lg:w-auto w-full pt-[6px]">
                                        <h4 className="text-nu9 pr-3">Filter by:</h4>
                                    </div>
                                    <div className="flex max-lg:flex-wrap lg:pt-0 pt-2">
                                        <div className="sm:pt-0 pt-3">
                                            <button className="tab-btn px-6 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full active" content-id="All">
                                                All
                                            </button>
                                        </div>
                                        <div className="sm:pt-0 pt-3">
                                            <button className="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex" content-id="Following">
                                                <span className="pr-2 sm:pt-0 pt-1"><i className="text-[14px] hover:text-primary text-secondary ph-fill ph-hexagon"></i></span>
                                                Following
                                            </button>
                                        </div>
                                        <div className="sm:pt-0 pt-3">
                                            <button className="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex" content-id="Trending">
                                                <span className="pr-2 sm:pt-0 pt-1"><i className="text-[14px] hover:text-primary text-secondary ph-fill ph-hexagon"></i></span>
                                                Top Trending
                                            </button>
                                        </div>
                                        <div className="sm:pt-0 pt-3">
                                            <button className="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex" content-id="Gainer">
                                                <span className="pr-2 sm:pt-0 pt-1"><i className="text-[14px] hover:text-secondary text-primary ph-fill ph-hexagon"></i></span>
                                                Top Gainer
                                            </button>
                                        </div>
                                        <div className="lg:pt-0 pt-3">
                                            <button className="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex" content-id="Gamefi">
                                                <span className="pr-2 sm:pt-0 pt-1"><i className="text-[14px] hover:text-secondary text-primary ph-fill ph-hexagon"></i></span>
                                                Gamefi 100 Index
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="aos-init aos-animate" data-aos="fade-left">
                                    <form action="#" className="flex px-2 xl:mt-0 mt-4 rounded-full bg-nu7">
                                        <input type="text" placeholder="Search" className="placeholder:text-nu1 xl:w-[170px] w-[200px] text-nu1 border-none outline-none" />
                                        <button>
                                            <span className="pt-3"><i className="px-2 py-2 rounded-full cursor-pointer bg-primary ph-bold ph-magnifying-glass"></i></span>
                                        </button>
                                    </form>
                                </div>
                            </div>

                            <div className="tab-contents">
                                <div className="content show" id="All">
                                    <div className="content-info w-full">
                                        <div className="grid grid-cols-12 gap-4">
                                            {gamesList?.map((game, index) => (
                                                <ProductCard key={index} game={game} />
                                            ))}


                                            {/* <ProductCard />
                                            <ProductCard />
                                            <ProductCard />
                                            <ProductCard />
                                            <ProductCard /> */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="bg-primary globl overflow-hidden">
                    <div className="bg-nu7 -rotate-3 sm:py-10 py-8 -mx-5">
                        <div className="container rotate-3">
                            <div className="flex justify-between items-center max-sm:flex-wrap">
                                <h1 className="text-nu1 sm:pl-0 pl-4">Newsletter</h1>
                                <div className="sm:mx-0 mx-4 px-4 sm:py-1 py-0 border-2 border-primary rounded-2xl flex items-center sm:mt-0 mt-4">
                                    <form action="https://game-wolf.vercel.app/email">
                                        <input type="email" name="email" className="border-none outline-none text-nu1 sm:w-auto w-[200px]" placeholder="Your email address" />
                                        <button>
                                            <span className="pt-4 pl-2">
                                                <i className="sm:px-3 px-2 sm:py-3 py-2 cursor-pointer rounded-2xl bg-secondary ph-bold ph-telegram-logo"></i>
                                            </span>
                                        </button>
                                    </form>
                                    {/* <!-- <span></span> --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <footer className="lg:pt-[120px] md:pt-20 pt-[60px] bg-nu2">
                    <div className="container mx-auto max-w-screen-xl">
                        <div className="grid grid-cols-12 gap-4">
                            <div className="lg:col-span-5 md:col-span-4 col-span-12">
                                <div className="flex items-center">
                                    <img className="w-[40px] h-[40px]" src="/images/logo.png" alt="" />
                                    <a href="index.html">
                                        <h3 className="pl-2 text-nu1 font-medium">GameWolf</h3>
                                    </a>
                                </div>
                                <p className="text-nu1 pt-10">
                                    HTML gaming has revolutionized the way we experience video games.
                                    With the advent of advanced graphics players are now realism and
                                    interactivity like never before.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="py-4 sm:mt-16 mt-10 bg-nu2">
                        <div className="flex max-sm:flex-wrap justify-center gap-8 items-center text-nu1">
                            <span className="text-nu9 font-semibold">
                                Copyright &copy; GameWolf
                            </span>
                        </div>
                    </div>
                </footer>

                {/* <ToastContainer /> */}


            </body>
        </>
    );
}

export default Game;
